import { RECEIVE_QUESTION_GAME, ASK_FINISHED,  QUESTION_ASKED, BET_STARTED, BET_FINISHED, RECEIVE_QUESTION_GAMES} from './actions'
import { matchNormalize } from '../../utils/normalize'
import { GET_QUESTION_GAME} from '../../events/DashboardToServer'
import { STARTED_MATCH } from '../matches'
export const SAVED_MATCH = 'SAVED_MATCH'


export const  question_game = (state = {}, action) => {
    switch (action.type) {

        case RECEIVE_QUESTION_GAMES:
            return Object.assign({}, state, matchNormalize(state, action.question_games))


        case RECEIVE_QUESTION_GAME:
            return Object.assign({}, state, matchNormalize(state, action.question_game))
                
        case SAVED_MATCH:
            const newDeleteState = { ...state }
            const keys = Object.keys(state);
            for (var i = 0; i < keys.length; i++){
                if (keys[i].startsWith(action.match.id))
                    delete newDeleteState[keys[i]];
            }
            return Object.assign({}, newDeleteState, matchNormalize(newDeleteState, action.question_game))

        case ASK_FINISHED:
            return {
            ...state,
                [action.game_id+" "+action.question_id]: {
                    ...state[action.game_id+" "+action.question_id],
                    end_ask_date: action.end_ask_date
                }
             }
        
        case QUESTION_ASKED:
        return {
            ...state,
                [action.game_id+" "+action.question.id]: {
                    ...state[action.game_id+" "+action.question.id],
                    ask_date: action.ask_date
                }
             }

        case BET_FINISHED:
             return {
            ...state,
                [action.game_id+" "+action.question_id]: {
                    ...state[action.game_id+" "+action.question_id],
                    end_bet_date: action.end_bet_date
                }
             }

        case BET_STARTED:
            return {
            ...state,
                [action.game_id+" "+action.question.id]: {
                    ...state[action.game_id+" "+action.question.id],
                    bet_date: action.start_bet_date,
                    game_id: action.game_id,
                    question_id: action.question.id,
                }
             }

        // se avvio la partita, resetto tutte le domande che così non risultano fatte
        case STARTED_MATCH:
            var newState = {...state}
            var newStateKeys = Object.keys(newState)
            for (var j = 0; j < newStateKeys.length; j++){
                if (newStateKeys[j].startsWith(action.match.id)){
                    newState[newStateKeys[j]] = {
                        ...newState[newStateKeys[j]],
                        bet_date: null,
                        end_bet_date: null,
                        ask_date:null,
                        end_ask_date:null
                    }
                }
            }
            return newState
             
        default:
            return state
    }
}

export const getQuestionGame = (socket) => {
    socket.emit(GET_QUESTION_GAME)
    return { type: GET_QUESTION_GAME }
}


// WEBPACK FOOTER //
// ./src/reducers/questionGame/index.js